import styled from "styled-components" // eslint-disable-line no-restricted-imports

export const Container = styled.div`
  position: fixed;
  bottom: 100px;
  left: 50%;
  width: 645px;
  max-width: 90%;
  transform: translateX(-50%);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
  z-index: 10001;
  a {
    cursor pointer
  }
`
